import { forwardRef } from "react";

const EyeIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M9 3.63281C5.56091 3.63281 2.44216 5.51437 0.140841 8.57052C-0.0469469 8.82091 -0.0469469 9.17071 0.140841 9.42109C2.44216 12.4809 5.56091 14.3625 9 14.3625C12.4391 14.3625 15.5578 12.4809 17.8592 9.42477C18.0469 9.17439 18.0469 8.82459 17.8592 8.57421C15.5578 5.51437 12.4391 3.63281 9 3.63281ZM9.2467 12.7755C6.96379 12.9191 5.07855 11.0375 5.22215 8.75095C5.33998 6.86571 6.86806 5.33763 8.7533 5.2198C11.0362 5.0762 12.9214 6.95776 12.7778 9.24435C12.6563 11.1259 11.1283 12.654 9.2467 12.7755ZM9.13256 11.0302C7.90273 11.1075 6.88647 10.0949 6.96747 8.86509C7.03007 7.84883 7.85486 7.02772 8.87113 6.96144C10.101 6.88412 11.1172 7.8967 11.0362 9.12652C10.9699 10.1465 10.1451 10.9676 9.13256 11.0302Z"
        fill={props.fill || "#003F88"}
      />
    </svg>
  ),
);

EyeIcon.displayName = "EyeIcon";

export default EyeIcon;
